import {ErrorHandler, Injectable} from '@angular/core';
import * as Sentry from '@sentry/browser';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
    private readonly angularErrorHandler = new ErrorHandler();

    handleError(error: any): void {
        const originalError = error && (error.ngOriginalError || error.rejection) || error;

        Sentry.captureException(originalError);
        this.angularErrorHandler.handleError(error);
    }
}
